import { render, staticRenderFns } from "./AttachmentsArchivedProccess.vue?vue&type=template&id=dd9be980&"
import script from "./AttachmentsArchivedProccess.vue?vue&type=script&setup=true&lang=js&"
export * from "./AttachmentsArchivedProccess.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports